//import Axios from 'axios'; // Asegúrate de importar Axios correctamente
import Axios from '../Axios';
import { notificationTemplates } from '../data/templates';

export const enviarPdf = async (base64) => {
    try {
  /*    // const url = 'https://localhost:7159/api/pdfToText';
      const url = 'https://apicteaminformeslegales.azurewebsites.net/api/pdfToText'; 
      // Cambia la URL según tu entorno
      const response = await Axios.post(
        url,
         base64 , // Enviamos el base64 directamente como un objeto JSON
        {
          headers: {
            'Content-Type': 'application/json' // Establecemos el tipo de contenido como JSON
          }
        }
      );
  
      return response.data;
    */
      } catch (error) {
      return Promise.reject(error);
    }
  };

  export const procesaTexto = async (decodeTexto) => {
    try {
  /*    //const url = 'https://localhost:7159/api/newpdfToText';
       const url = 'https://apicteaminformeslegales.azurewebsites.net/api/newpdfToText'; 
      // Cambia la URL según tu entorno
      const response = await Axios.post(
        url,
        decodeTexto , // { "texto": "", "idDocumento": "", "patrones": [{}] }
        {
          headers: {
            'Content-Type': 'application/json' // Establecemos el tipo de contenido como JSON
          }
        }
      );
  
      return response.data;
    */
      } catch (error) {
      return Promise.reject(error);
    }
  };



  export const salidaPdf = async (armaSalida) => {
    try {
   /*
      //const url = 'https://localhost:7159/api/htmlToPdf';
       const url = 'https://apicteaminformeslegales.azurewebsites.net/api/htmlToPdf'; 
      // Cambia la URL según tu entorno
      const response = await Axios.post(
        url,
         armaSalida , 
        {
          headers: {
            'Content-Type': 'application/json' // Establecemos el tipo de contenido como JSON
          }
        }
      );
  
      return response.data;
    */
      } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearMensaje = (idDestinatario,tipo, data) => {
    
    if (!notificationTemplates[tipo]) {
      throw new Error(`Template no encontrado para tipo: ${tipo}`);
    }

    const { subject, html } = notificationTemplates[tipo](data);

    return {
      usuario: idDestinatario,
      subjet: subject,
      htmlContent: html,
    };
  };

  export const notificarUsuario = async (newData) => {
    try {

        const {data}  = await Axios.post(
            '/conecta/notifica', newData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };